import { render, staticRenderFns } from "./PortfolioMoveStockDialog.vue?vue&type=template&id=0ed8c454&scoped=true&"
import script from "./PortfolioMoveStockDialog.vue?vue&type=script&lang=js&"
export * from "./PortfolioMoveStockDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioMoveStockDialog.vue?vue&type=style&index=0&id=0ed8c454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8c454",
  null
  
)

export default component.exports